import { AdminHeader, AdminSidebar } from 'components/molecules';
import './PastLeaveApprovals.scss';

const PastLeaveApprovals = () => {
  return (
    <>
      <AdminHeader />
      <div className="dashboard-wrapper">
        <AdminSidebar />
        <div>
          <p>Past Leave Approvals</p>
          {/* Leave requests list goes here */}
        </div>
      </div>
    </>
  );
};

export default PastLeaveApprovals;
